<template>
  <div class="emd-context-select">
    <header class="emd-context-select__header">
      <nav class="emd-segmented-controls">
        <button class="emd-segmented-controls__item"
          :class="{ '_active': activeSegment === 'production' }"
          @click="toggleSegment('production')"
        >
          {{$t('segment.prd')}}
        </button>
        <button class="emd-segmented-controls__item _warning"
          @click="toggleSegment('test')"
          :class="{ '_active': activeSegment === 'test' }"
        >
          {{$t('segment.tst')}}
        </button>
      </nav>
    </header>
    <main class="emd-context-select__body">
        <keep-alive>
          <component v-if="merchant && account" :is="activeSegmentPartial" :merchant="merchant" :account="account" />
        </keep-alive>
    </main>
  </div>
</template>

<i18n>
{
  "pt-BR": {
    "segment": {
      "prd": "Produção",
      "tst": "Teste"
    },
    "cta": {
      "createTestAccount": "Criar Conta de Teste"
    }
  },
  "en-US": {
    "segment": {
      "prd": "Production",
      "tst": "Test"
    },
    "cta": {
      "createTestAccount": "Create Test Account"
    }
  }
}
</i18n>

<script>
import InteractiveListProduction from './InteractiveListProduction.vue'
import InteractiveListTest from './InteractiveListTest.vue'
export default {
  name: 'AppContextSelect',
  data () {
    return {
      activeSegment: 'production'
    }
  },
  computed: {
    merchant () {
      return this.$store.getters.merchantData
    },
    account () {
      return this.$store.getters.accountData
    },
    isTestAccount () {
      return this.account.account_type.key === 'test'
    },
    accountName () {
      return !this.isTestAccount ? this.account.name : this.account.master_account_name
    },
    activeSegmentPartial () {
      return this.activeSegment === 'production'
        ? InteractiveListProduction
        : InteractiveListTest
    }
  },
  methods: {
    toggleSegment (segment) {
      this.activeSegment = segment
    },
    goToCreateTestAccount () {
      this.$parent.contextDropdown()
      this.$router.push({ name: 'create-test-account' }).catch(err => err)
    }
  },
  mounted () {
    this.activeSegment = !this.isTestAccount ? 'production' : 'test'
  }
}
</script>
